import {isDev} from './common';

/**
 * API
 */
const API_DOMAIN = process.env.NEXT_PUBLIC_API_DOMAIN;
const API_VERSION = `/api/v3`;
export const API_HOST = `https://${API_DOMAIN}`;
export const API_URL = `${API_HOST}${API_VERSION}`;

/**
 * Map
 */
export const DEFAULT_COORDINATES = '47.0275770000137,28.83204'; // str. Stefan cel Mare, 124
// str. Stefan cel Mare, 124
export const DEFAULT_COORDINATES_OBJ = {
  lat: 47.02,
  lon: 28.84,
};

/**
 * Defaults
 */
export const ROUTES = {
  protected: ['/profile', '/cards', '/promo', '/favourites', '/order'],
  auth: ['/login'],
};

export const SUPPORT_PHONE_NUMBER = '022899999';

export const SITE_URL = isDev ? 'http://localhost:8080' : 'https://straus.md';
export const LANGUAGES = ['ro', 'ru', 'en'];
export const TAWK_ID = '5799cb9f8642ec804b784810';
/**
 * OneSignal
 */
export const OneSignalKey = isDev ? '100c6c28-21f8-4da3-a9b2-f5a6e93f6f57' : '6a99cef2-151b-44ac-b138-0e122ea00293';
export const OneSignalSafariWebId = isDev
  ? 'web.onesignal.auto.30b8db8e-86b1-4367-8886-055d3d362718'
  : 'web.onesignal.auto.5136aa20-d33c-4de6-8d7f-c3f8c4b264dc';

export const POPOVER_REGIONS = [
  {
    id: 1,
    translationKey: 'region.centru',
    coordinates: {
      latitude: 47.017,
      longitude: 28.847,
    },
    translations: {
      en: 'Centru',
      ro: 'Centru',
      ru: 'Центр',
    },
  },
  {
    id: 2,
    translationKey: 'region.botanica',
    coordinates: {
      latitude: 46.9695,
      longitude: 28.8941,
    },
    translations: {
      en: 'Botanica',
      ro: 'Botanica',
      ru: 'Ботаника',
    },
  },
  {
    id: 3,
    translationKey: 'region.ciocana',
    coordinates: {
      latitude: 47.0326,
      longitude: 28.9048,
    },
    translations: {
      en: 'Ciocana',
      ro: 'Ciocana',
      ru: 'Чеканы',
    },
  },
  {
    id: 4,
    translationKey: 'region.riscani',
    coordinates: {
      latitude: 47.0489,
      longitude: 28.8583,
    },
    translations: {
      en: 'Rîșcani',
      ro: 'Rîșcani',
      ru: 'Рышкановка',
    },
  },
  {
    id: 5,
    translationKey: 'region.buiucani',
    coordinates: {
      latitude: 47.0357,
      longitude: 28.8005,
    },
    translations: {
      en: 'Buiucani',
      ro: 'Buiucani',
      ru: 'Буюканы',
    },
  },
];

export const kTestNumbers = [
  '+37369969719',
  '+37360425740',
  '+37368281810',
  '+37368988883',
  '+37368230144',
  '+37361078679',
  '+37368563354',
  '+37376766635',
  '+37378329483',
  '+37368608966',
  '+37369099556', //Igor Mihailov
  '+37368889505', //Roman Chicu
  '+37378290993', //Anghelina
  '+37367660335',
  '+37360804535',
  '+37368934534',
  '+37379772001',
];
